import Link from 'next/link'
import { Stack } from '../../../Stack'
import { CopyText, CopyWrapper } from '../../DiscountBanner.styles'

export const BlackFridayBanner = (params: {
  disableClickPages: boolean
  displayAmount: string
}) => {
  const { disableClickPages, displayAmount } = params

  const content = (
    <CopyWrapper
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap="0"
      clickable={!disableClickPages}
    >
      <Stack
        direction={{ '@initial': 'column', '@bp3': 'row' }}
        justifyContent="center"
        alignItems="center"
        gap="0"
      >
        <CopyText>It&apos;s Black Friday. For Dogs!</CopyText>
        <CopyText css={{ display: 'none', '@bp3': { display: 'inline' } }}>&nbsp;</CopyText>
        <CopyText>Get $100 Off</CopyText>
      </Stack>
    </CopyWrapper>
  )

  return <>{disableClickPages ? content : <Link href="/meal-plan">{content}</Link>}</>
}
